import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	win: 6
};

export const Theme9SubtopicOneActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema9.activities.subtema1], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 9 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub1a01)
	})


	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema9.topic1.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Aprende sobre SASSO.' />
					<DialogBarNew
						dialog={`Hemos llegado al último tema de la capacitación. Te has esforzado mucho para llegar hasta aquí. En esta ocasión te presentaré información relevante sobre SASSO.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. SASSO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub1a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Recuerda que se presentarán misiones por resolver que te darán puntos para culminar con tu capacitación.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub1a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`SASSO, es el Sistema de Administración de Seguridad y Salud Ocupacional.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T9.subtema1.sub1a04)
							ObserverEmitter.emit(EVENTS.characterAnimations.pensativo);
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Es el área destinada a apoyar en la prevención de los accidentes en nuestros colaboradores (as), vigilar que las condiciones de trabajo sean seguras, así como cuidar y prevenir la salud y bienestar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="¡Estupendo! Has completado el módulo de SASSO, fortaleciendo tu seguridad en situaciones riesgosas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema9.activities.subtema1
								})
							);
							navigator("/home9/tema9/subtema1/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
